/* eslint-disable @typescript-eslint/naming-convention */
import * as _React from 'react';
import * as _assign from 'lodash/assign';
import { bindActionCreators as _bindActionCreators } from 'redux';
import {
    connectwith as _connectwith
} from '@inwink/react-utils/decorators';

import { InwinkLoader as _InwinkLoader } from './components/ui/inwinkloader';
import { translateEventLabel as _translateEventLabel } from './services/eventservice';
import { EventLabel as _EventLabel } from './components/ui/eventlabel';
import * as _buttons from './components/ui/buttons';
import * as _i18nservice from './services/i18nservice';

//export { TransitionGroup, CSSTransition } from 'react-transition-group';
export { LoadingState, LoadingProgress } from '@inwink/loadable';
export { type IPopoverManager, PopoverManager, WithPopoverManager } from '@inwink/modals/popovermgr';
export { CMSContextProvider } from './components/cmscontext';
export { withI18nHelper } from '@inwink/i18n/reactcontext';
export { toastError, toastInfo, toastSuccess, toastWarning } from './toasts';
export const React = _React;
export const Component = _React.Component;
export const bindActionCreators = _bindActionCreators;
export const connectwith = _connectwith;
export const assign = _assign;
export const translate = _i18nservice.translate;
export const translateBag = _i18nservice.translateBag;
export const I18NResourcesContext = _i18nservice.I18NResourcesContext;
export const i18NHelperContext = _i18nservice.i18NHelperContext;
export const AppLabel = _i18nservice.AppLabel;
export const DisplayDate = _i18nservice.DisplayDate;
export const DynLabel = _i18nservice.DynLabel;
export const AppTextLabel = _i18nservice.AppTextLabel;
export const AppAsyncButton = _buttons.AppAsyncButton;
export const AppButton = _buttons.AppButton;
export const Loader = _InwinkLoader;
export const EventLabel = _EventLabel;
export const translateEventLabel = _translateEventLabel;

export const dateWithoutTimezone = "YYYY[-]MM[-]DD[T]HH[:]mm[:]ss";

export const companionDefaultHosts = [
    "dev-fo.inwink.ninja",
    "dev-ariane-fo.inwink.ninja", 
    "dev-corbier-fo.inwink.ninja", 
    "dev-dorothee-fo.inwink.ninja", 
    "dev-jacky-fo.inwink.ninja", 
    "dev-patrick-fo.inwink.ninja",
    "sdb-fo.inwink.ninja",
    "stg-fo.inwink.ninja", 
    "pre-fo.inwink.ninja",
    "events.inwink.com",
    "event.inwink.com"
];


export type Nullable<T> = T | null;
